import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useEffect, useRef } from 'react';
import { getDisplayName } from '@panneau/core/utils';
import ReactDOM from 'react-dom';
import { useModal } from '@panneau/core/contexts';
import { useKeyboardKeys, KEYCODES } from '@panneau/core/hooks';

/* eslint-disable react/no-array-index-key, react/jsx-props-no-spreading */

// import ElementPortal from '@panneau/element-portal';

var propTypes$2 = {
  id: PropTypes.string,
  data: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  children: PropTypes.node
};
var defaultProps$2 = {
  id: null,
  data: null,
  children: null
};
var ModalPortal = function ModalPortal(_ref) {
  var id = _ref.id,
    data = _ref.data,
    children = _ref.children;
  var _useModal = useModal(),
    _useModal$container = _useModal.container,
    container = _useModal$container === void 0 ? null : _useModal$container,
    _useModal$register = _useModal.register,
    register = _useModal$register === void 0 ? null : _useModal$register,
    _useModal$unregister = _useModal.unregister,
    unregister = _useModal$unregister === void 0 ? null : _useModal$unregister;
  var finalId = useMemo(function () {
    return id !== null ? id : "modal-".concat(new Date().getTime());
  }, [id]);
  useEffect(function () {
    if (register !== null) {
      register(finalId, data);
    }
    return function () {
      if (unregister !== null) {
        unregister(finalId, data);
      }
    };
  }, [finalId, data, register, unregister]);
  return container !== null ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};
ModalPortal.propTypes = propTypes$2;
ModalPortal.defaultProps = defaultProps$2;

var styles = {"modal":"panneau-element-modal-modal","center":"panneau-element-modal-center","inner":"panneau-element-modal-inner","top":"panneau-element-modal-top","button":"panneau-element-modal-button","modalsContainer":"panneau-element-modal-modalsContainer","modals":"panneau-element-modal-modals","hasModals":"panneau-element-modal-hasModals"};

var propTypes$1 = {
  id: PropTypes.string,
  title: PropTypes.string,
  position: PropTypes.oneOf(['center', 'top']),
  onClose: PropTypes.func,
  children: PropTypes.node
};
var defaultProps$1 = {
  id: null,
  title: null,
  position: 'center',
  onClose: null,
  children: null
};
var Modal = function Modal(_ref) {
  var id = _ref.id,
    onClose = _ref.onClose,
    children = _ref.children,
    position = _ref.position,
    title = _ref.title;
  var name = getDisplayName(children);
  var finalId = useMemo(function () {
    return id || name || 'Modal';
  }, [id, name]);
  var data = useMemo(function () {
    return {
      title: title,
      onClose: onClose
    };
  }, [title, onClose]);
  return /*#__PURE__*/React.createElement(ModalPortal, {
    id: finalId,
    data: data
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.modal, _defineProperty({}, styles[position], position !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['modal', 'fade', 'show', 'd-block', styles.inner]),
    tabIndex: "-1"
  }, children)));
};
Modal.propTypes = propTypes$1;
Modal.defaultProps = defaultProps$1;

var propTypes = {
  theme: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  theme: null,
  className: null
};
var Modals = function Modals(_ref) {
  var theme = _ref.theme,
    className = _ref.className;
  var _useModal = useModal(),
    _useModal$modals = _useModal.modals,
    modals = _useModal$modals === void 0 ? null : _useModal$modals,
    _useModal$setContaine = _useModal.setContainer,
    setContainer = _useModal$setContaine === void 0 ? null : _useModal$setContaine,
    _useModal$closeLastMo = _useModal.closeLastModal,
    closeLastModal = _useModal$closeLastMo === void 0 ? null : _useModal$closeLastMo;
  var containerRef = useRef(null);
  useEffect(function () {
    if (setContainer !== null) {
      setContainer(containerRef.current);
    }
  }, [setContainer]);
  useEffect(function () {
    if (document.body) {
      if (modals !== null && modals.length > 0) {
        document.body.className = 'modal-open';
      } else {
        document.body.className = '';
      }
    }
  }, [modals]);
  useKeyboardKeys(_defineProperty({}, KEYCODES.ESCAPE, closeLastModal));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.modalsContainer, _defineProperty({}, className, className)]),
    "data-bs-theme": theme !== null ? theme : null,
    style: {
      color: theme === 'dark' ? '#FFF' : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.modals, _defineProperty({}, styles.hasModals, modals !== null && modals.length > 0)]),
    ref: containerRef
  }));
};
Modals.propTypes = propTypes;
Modals.defaultProps = defaultProps;

export { Modal, ModalPortal, Modals, Modal as default };
